import { render } from "./historyWellList.vue?vue&type=template&id=3be59fd5&scoped=true"
import script from "./historyWellList.vue?vue&type=script&lang=js"
export * from "./historyWellList.vue?vue&type=script&lang=js"

import "./historyWellList.vue?vue&type=style&index=0&id=3be59fd5&scoped=true&lang=css"
import "./historyWellList.vue?vue&type=style&index=1&id=3be59fd5&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be59fd5"]])

export default __exports__